import { createBrowserRouter, createMemoryRouter, RouterProvider } from 'react-router-dom'

import { routes } from './routes'
import { CreateRouterProps } from './types'

const AppRouterProvider = (props: CreateRouterProps) => {
    if (props.strategy === 'local') {
        return <RouterProvider router={createBrowserRouter(routes)} />
    }

    const initialEntries = [props.initialPathname || '/']
    return <RouterProvider router={createMemoryRouter(routes, { initialEntries })} />
}

export default AppRouterProvider
